import { useTranslation } from 'react-i18next';
import { useConfirmationContext } from '../../contexts/ConfirmationContext';
import AppModal from './Modal';

const ModalConfirmDelete = () => {
    const { t } = useTranslation();

    const { deleteConfirmationText, setDeleteConfirmationText, setDeleteConfirmed } =
        useConfirmationContext();

    const confirm = () => {
        setDeleteConfirmed(true);
        setDeleteConfirmationText(null);
    };

    const cancel = () => {
        setDeleteConfirmationText(null);
    };

    if (!deleteConfirmationText) return <></>;

    return (
        <AppModal
            safeAction={cancel}
            safeText={t('button.no_cancel') as string}
            dangerAction={confirm}
            dangerText={t('button.yes_delete') as string}
            dangerCss="btn-danger"
        >
            <h3>{t('feedback.confirm_action')}</h3>
            <p>{deleteConfirmationText}</p>
        </AppModal>
    );
};

export default ModalConfirmDelete;
